import * as Yup from 'yup'

const rejectMenuScrapingSchema = Yup.object().shape({
  scrapingRejectedComment: Yup.string()
    .required(`Scraping rejection comment is required.`)
    .nullable(),
})

export default rejectMenuScrapingSchema
